<template>
<div class="digbox">
    <div class="hint">请用微信扫描二维码</div>
</div>
</template>
<script>
export default {
        name: "Hintstorage",
    data(){
        return{
        }
       
    },
     methods:{

        }
}
</script>
<style lang="less" scoped>
.digbox{

    height: 600px;
    display: flex;
    justify-content: center;
    align-items: center;
    .hint{
        font-size: 25px;
    }
}

</style>
